import { DataTable, type DataTableColumn } from '@atrvd/saas-ui'
import type { OrganizationFacility } from '@/hooks/useOrganizationAdmin'
import { queryErrorDisplay, type TableQueryStateProps } from '@/components/common/queryErrorDisplay'

interface OrganizationFacilitiesTableProps extends TableQueryStateProps {
  facilities: OrganizationFacility[]
}

const COLUMNS: DataTableColumn<OrganizationFacility>[] = [
  { key: 'name', header: 'Name', render: (facility) => facility.name, cellClassName: 'font-medium' },
  { key: 'code', header: 'Code', render: (facility) => facility.code || '—' },
  {
    key: 'bankConnectionsCount',
    header: 'Bank connections',
    render: (facility) => facility.bankConnectionsCount,
  },
  { key: 'isActive', header: 'Status', render: (facility) => (facility.isActive ? 'Active' : 'Inactive') },
]

/** Admin list of an organization's facilities with their bank connection count and status. Unpaged. */
export function OrganizationFacilitiesTable({
  facilities,
  loading,
  refreshing,
  error,
  retrying,
  onRetry,
}: OrganizationFacilitiesTableProps) {
  const { banner, tableError } = queryErrorDisplay({ error, retrying, onRetry }, facilities.length)
  return (
    <>
      {banner}
      <DataTable
        columns={COLUMNS}
        data={facilities}
        rowKey={(facility) => facility.id}
        itemName="facilities"
        showColumnControls={false}
        loading={loading}
        refreshing={refreshing}
        error={tableError}
        emptyState={<p className="text-center text-muted-foreground">No facilities found</p>}
      />
    </>
  )
}
